import { render, staticRenderFns } from "./MovingArrow.vue?vue&type=template&id=29407b3d&"
import script from "./MovingArrow.vue?vue&type=script&lang=js&"
export * from "./MovingArrow.vue?vue&type=script&lang=js&"
import style0 from "./MovingArrow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports